export default "__VITE_ASSET__D09RGar$__"